import { render, staticRenderFns } from "./device-statistics-report.vue?vue&type=template&id=93af6d0a&scoped=true&"
import script from "./device-statistics-report.vue?vue&type=script&lang=js&"
export * from "./device-statistics-report.vue?vue&type=script&lang=js&"
import style0 from "./device-statistics-report.vue?vue&type=style&index=0&id=93af6d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93af6d0a",
  null
  
)

export default component.exports